/**
 * @generated SignedSource<<20508bf6826306b5e6e079212212283b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetDOIFragment$data = {
  readonly doi: {
    readonly full: string;
    readonly short: string | null | undefined;
    readonly url: Url;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "DatasetDOIFragment";
};
export type DatasetDOIFragment$key = {
  readonly " $data"?: DatasetDOIFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetDOIFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetDOIFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DOI",
      "kind": "LinkedField",
      "name": "doi",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "full",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "short",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};

(node as any).hash = "910de8e0274d8b275ddc69115f0e506f";

export default node;
